import { ObjectHistory } from './ObjectHistory';

const name = 'ObjectHistory';

export { ObjectHistory, name };
